import React from "react";
import { NextAction } from "../utils/nextAction";

const NextActionChip: React.FC<{ action: NextAction }> = ({ action }) => (
  <span
    className={`xgs-invoice-factoring__next-action xgs-invoice-factoring__next-action--${action.tone}`}
    title={action.label}
  >
    {action.label}
  </span>
);

export default NextActionChip;
